import type { Map } from "mapbox-gl"

export const PARCEL_SOURCE_LAYER = "gold.parcels"

export function addCadastre(
	map: Map,
	{
		baseUrl,
		sourceName,
		layerName,
		visibleLayers,
	}: {
		baseUrl: string
		sourceName: string
		layerName: string
		visibleLayers: string[]
	}
): void {
	map.addSource(sourceName, {
		type: "vector",
		tiles: [`${baseUrl}/${PARCEL_SOURCE_LAYER}/{z}/{x}/{y}.pbf?filter=status='active'`],
		promoteId: "parcel_id",
	})
	map.addLayer({
		id: layerName,
		source: sourceName,
		"source-layer": PARCEL_SOURCE_LAYER,
		slot: "top",
		type: "fill",
		layout: {
			visibility: visibleLayers.includes("cadastre") ? "visible" : "none",
		},
		paint: {
			"fill-color": [
				"case",
				["boolean", ["feature-state", "targetHighlight"], false],
				"rgba(200, 65, 65, 0.25)",
				["boolean", ["feature-state", "highlight"], false],
				"rgba(29, 191, 115, 0.2)",
				["boolean", ["feature-state", "hover"], false],
				"rgba(127, 127, 127, 0.15)",
				"rgba(29, 191, 115, 0)",
			],
			"fill-outline-color": "#0bab50",
		},
		minzoom: 13,
		metadata: { custom: true },
	})
}
